import { useEffect, useState } from 'react';

import { applyTheme, resolveTheme, watchSystemTheme, type ResolvedTheme } from '@/lib/theme';
import { useSettingsStore } from '@/stores/settings-store';

export function useThemeMode(): {
  resolved: ResolvedTheme;
  preference: 'system' | 'light' | 'dark';
  setPreference: (value: 'system' | 'light' | 'dark') => void;
} {
  const preference = useSettingsStore((state) => state.theme);
  const setPreference = useSettingsStore((state) => state.setTheme);
  const [resolved, setResolved] = useState<ResolvedTheme>(() => resolveTheme(preference));

  useEffect(() => {
    const update = () => setResolved(applyTheme(preference));
    update();

    if (preference !== 'system') return;
    return watchSystemTheme(update);
  }, [preference]);

  return { resolved, preference, setPreference };
}
